<template>
    <div class="page checkstand-page">
        <div class="top">
            <div class="top-content">
                <div class="top-content-top">
                    <div class="top-content-top-items">已选套餐：</div>
                    <div class="time">{{ dataForm.packageName }}</div>
                </div>

                <div class="top-content-middle">
                    <div class="top-content-top-items">套餐有效期：</div>
                    <div class="time">{{ dataForm.startTime }} 至 {{ dataForm.endTime }}</div>
                </div>
                <div class="top-content-middle">
                    <div class="top-content-top-items">套餐价格：</div>
                    <div class="time">{{ dataForm.showSalePrice }}元</div>
                </div>
                <div class="top-content-middle">
                    <div class="top-content-top-items">账户余额：</div>
                    <div class="time">{{ userYu }}元</div>
                </div>
            </div>
        </div>

        <div class="section">
            <div class="page-payment">
                <div class="name">支付方式</div>
                <van-radio-group v-model="radio" @change="chengPayType()">
                    <van-cell-group>
                        <template v-for="(item, index) in payTypeList">
                            <van-cell :title="titleYu" v-if="item === 'yeCollectConfig'" clickable class="yue-icon"
                                :key="index">
                                <template #right-icon>
                                    <van-radio name="yeCollectConfig" />
                                </template>
                            </van-cell>
                            <div class="yue-swr" v-if="item === 'yeCollectConfig'">
                                <div class="b-z">
                                    为您优选，余额直冲套餐更划算
                                </div>
                                <div class="c-flex">
                                    <div class="c-z" v-for="(item, index) in payListType" :key="index"
                                        @click="change(item, index)">
                                        <div class="c-z-item" :class="[inx === index ? 'c-z-active' : '']">
                                            <div class="items">
                                                <span>充</span>
                                                {{ item.amount }}
                                                <span>元</span>
                                            </div>
                                            <div class="item1">
                                                到账{{ item.amount * 1 + item.giftBalance * 1 }}元
                                            </div>
                                            <div v-if="item.title" class="f-d">{{ item.title }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <van-cell
                                v-if="item !== 'aliCollectConfig' && item !== 'yeCollectConfig' && item !== 'jdCollectConfig' && isMoreH"
                                title="在线支付" clickable class="wx-icon" :key="index">
                                <template #right-icon>
                                    <van-radio :name="item" />
                                </template>
                            </van-cell>
                            <van-cell title="在线支付" v-if="item === 'aliCollectConfig' && isMoreH" clickable class="ali-icon"
                                :key="index">
                                <template #right-icon>
                                    <van-radio name="aliCollectConfig" />
                                </template>
                            </van-cell>

                        </template>
                    </van-cell-group>
                    <div class="morePay" v-if="!isMoreH" @click="isMoreH = !isMoreH">更多支付 <van-icon
                            :name="isMoreH ? 'arrow-up' : 'arrow-down'" /></div>
                </van-radio-group>
            </div>
        </div> 
        <div class="footer">
            <div class="preferential" @click="selectCoupon" v-if="!isShieldAgent && dataForm.price > 0">
                <div class="roll">惠</div>
                <div class="roll-up">优惠卷</div>
                <div class="roll-proce">- {{ dataForm.price }} 元</div>
            </div>
            <div class="payment">
                <div class="payment-items" v-if="inxPrice && inxPrice > 0&&inxYuFlg">
                    <div class="">需支付：</div>
                    <div class="price">￥<span>
                            {{ inxPrice }}
                        </span></div>
                    <div class="price-small">0</div>
                </div>
                <div class="payment-items" v-else>
                    <div class="">需支付：</div>
                    <div class="price">￥<span>
                            {{ (dataForm.showSalePrice - (dataForm.price + dataForm.vipSubPrice)).toFixed(2) }}
                        </span></div>
                    <div class="price-small">{{ dataForm.price + dataForm.vipSubPrice }}</div>
                </div>
                <div class="payment-btn">
                    <!-- 支付余额 -->
                    <van-button type="primary" block round color="#397EF5" v-if="inxPrice && inxPrice > 0&&inxYuFlg"
                        @click="change(inxData, inx)">去支付</van-button>
                    <!-- 支付套餐 -->
                    <van-button type="primary" block round color="#397EF5" v-else @click="sumbit">去支付</van-button>
                </div>
            </div>
        </div>
        <div v-html="payUrl"></div>
        <div class="shareit" v-if="is_WeChat">
            <img class="arrow" src="@/assets/img/arrowhead.png" />
            <div class="follow">支付宝支付请右上角点击 在游览器打开 进行支付,<br />支付成功后 请重新扫码登录进行激活操作<br /></div>
        </div>

        <!-- 密码框 -->
        <div class="van-overlay" style="z-index: 1999" v-show="showPasswordPanel"></div>
        <div class="van-popup van-popup--round van-popup--center passwordPanel"
            style="z-index: 2000; min-height: 35%; min-width: 80%" v-show="showPasswordPanel"
            :style="{ top: PasswordPanelTop + '%' }">
            <div class="cancelInput">
                <van-icon name="cross" @click="cancelInputPassword()" />
            </div>
            <p style="color:Red">初始支付密码默认6个0</p>
            <h1 v-if="dataForm.price || dataForm.vipSubPrice">
                <span>￥</span>
                {{ dataForm.showSalePrice - (dataForm.price + dataForm.vipSubPrice) > 0 ? (dataForm.showSalePrice -
                    (dataForm.price + dataForm.vipSubPrice)).toFixed(2) : 0 }}
            </h1>
            <h1 v-else>￥{{ dataForm.showSalePrice * 1 }}</h1>

            <!-- 密码输入框 -->
            <van-password-input :value="yuePayParam.payPass" :focused="showKeyboard" @focus="onfocus()" />
        </div>

        <van-overlay :show="overlay" z-index="2020">
            <div class="wrapper">
                <van-loading type="spinner" color="#fff" />
            </div>
        </van-overlay>
        <!-- 密码框  end -->

        <!-- 数字键盘 -->

        <van-number-keyboard id="keyboardDefined" :z-index="2015" :show="showKeyboard" @input="onInput" @delete="onDelete"
            @blur="showKeyboard = false" />

        <van-dialog v-model="showToYuInvent" title="余额不足" :show-confirm-button="false">
            <div class="dialog-text">
                您的余额不足，请充值余额后再来购买套餐，是否前往充值页面？
            </div>
            <div class="btn-vis">
                <van-button type="primary" class="dialog-btn2" @click="cacelYu">取消</van-button>
                <van-button type="primary" class="dialog-btn3" @click="toYuInvent">前往订购</van-button>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from "@/api/user.js";
export default {
    data() {
        return {
            isMoreH: false, // false
            isShieldAgent: localStorage.getItem('isShieldAgent') == 1 ? true : false,
            titleYu: '账户余额支付',
            checked: true,
            result: [],
            radio: 'yeCollectConfig',
            payUrl: '',
            is_WeChat: false,
            payTypeList: [],
            dataForm: {},
            yuePayParam: {
                orderNo: "",
                payPass: "",
                iccid: localStorage.getItem("iccid"),
                mobile: localStorage.getItem("mobile"),
            },
            sObj: {},
            inx: '',
            inxData: {},//默认余额选中的参数
            inxPrice: '',// 要展示的支付余额
            inxYuFlg: false, //是否要展示余额金额

            payListType: [],
            //密码输入
            showPasswordPanel: false,
            showKeyboard: false,
            overlay: false,
            showToYuInvent: false,
            PasswordPanelTop: 50,
            showKeyboardZIndex: 2015,

            userYu: '0'
        }
    },
    async created() {
        await wxRequest("sim/uniorder/param", { iccid: localStorage.getItem('iccid') }, "post").then(res => {
            if (res.data.code === '200') {
                this.sObj = res.data.data[0]
                this.payListType = res.data.data.filter((item, i) => i < 3)
            }
        })

        var price = localStorage.getItem('userSimAmount');
        if (price > 0) {
            this.userYu = (price / 100).toFixed(2);
        }

        this.dataForm = this.$route.query.params ? JSON.parse(decodeURIComponent(this.$route.query.params)) : {}
        if (this.dataForm.pkgShowYearPrice && this.dataForm.pkgShowYearPrice > 0) {
            this.isMoreH = true;
            this.radio = '';
        } else if (this.dataForm.showLimit == 0) {
            this.isMoreH = true;
            this.radio = '';
        } else {
            //默认余额支付，并且选中第二个余额参数
            if (this.payListType && this.payListType.length > 1) {
                this.radio = 'yeCollectConfig';
                this.inx = 1;
                this.inxData = this.payListType[1];
                this.inxPrice = this.inxData.amount;
                this.inxYuFlg = true;
            }

        }
        await wxRequest("/order/pay/chanle", { iccid: localStorage.getItem("iccid"), ali: localStorage.getItem("htmlType") }, "post").then((res) => {
            if (res.data.code === '200') {
                for (let i = 0; i < res.data.data.length; i++) {
                    this.payTypeList.push(res.data.data[i].typeKey);
                }
            } else if (res.data.code === '205') {
                // for (let i = 0; i < res.data.data.length; i++) {
                //     this.payTypeList.push(res.data.data[i].typeKey);
                // }
                this.payTypeList.push('yeCollectConfig')
            }
        });

        var pop = {
            iccid: this.$store.state.iccid,
            pkgId: this.dataForm.soldPackageId,
            isAdmin: this.dataForm.isAdmin,
            isNextMonth: this.dataForm.isNextMonth
        }
        await wxRequest("/sim/activity/timer", pop, "post").then((res) => {
            if (res.data.code === '200') {
                this.dataForm.startTime = res.data.data.startTime;
                this.dataForm.endTime = res.data.data.endTime;
            }
        });


        // secondaryId,primaryId 如果选了优惠券，优惠券里面的id都在this.dataForm里面可以获取到
        this.selectIsAutoState()
    },
    methods: {
        chengPayType() {
            if (this.radio === 'yeCollectConfig') {
                this.inxYuFlg = true;
            } else {
                this.inxYuFlg = false;
            }
        },
        toYuInvent() {
            this.$router.replace("/newUser/recharge");
        },
        cacelYu() {
            this.showToYuInvent = false;
        },
        toggle() {
            this.$refs.checkboxes.toggle();
            const param = {
                iccid: this.$store.state.iccid,
                isAuto: this.result.length === 0 ? 1 : 0
            }
            wxRequest('sysUser/account/update/isAuto/state/add', param, 'post').then(res => {
                if (res.data.code === '200') {
                    this.selectIsAutoState()
                } else {
                    Dialog.alert({ title: '修改提示', message: res.data.message })
                }
            })
        },
        selectCoupon() {
            this.$router.push({ path: '/new/coupon', query: { params: encodeURIComponent(JSON.stringify(this.dataForm)) } });
        },
        selectIsAutoState() {
            const param = {
                iccid: this.$store.state.iccid
            }
            wxRequest('sysUser/account/select/isAuto/state/add', param, 'post').then(res => {
                if (res.data.code === '200') {
                    this.result = res.data.data === 0 ? [] : ['1']
                }
            })
        },
        onfocus() {
            this.showKeyboard = true;
            this.PasswordPanelTop = 30;
        },
        cancelInputPassword() {
            this.yuePayParam.payPass = "";
            this.showPasswordPanel = false;
        },
        onDelete() {
            this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, this.yuePayParam.payPass.length - 1);
        },
        onInput(key) {
            this.yuePayParam.payPass = (this.yuePayParam.payPass + key).slice(0, 6);
            if (this.yuePayParam.payPass.length >= 6) {
                this.PasswordPanelTop = 50;
                this.yuePayParam.primaryId = this.dataForm.primaryId || ''
                this.yuePayParam.secondaryId = this.dataForm.secondaryId || ''
                this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, 6);
                this.overlay = true;
                wxRequest("order/sysUser/wx/ye/pkg", this.yuePayParam, "post").then((res) => {
                    if (res.data.code == 200) {
                        Toast.success(res.data.message);
                        this.yuePayParam.payPass = "";
                        this.overlay = false;
                        let self = this;
                        Dialog.alert({ title: '订购成功', message: '您已订购成功，稍后跳转到查询套餐页面' })
                        setTimeout(function () {
                            self.$router.push({
                                path: "/newUser/home",
                                query: {
                                    iccid: self.$store.state.iccid,
                                },
                            }).catch(() => { });
                        }, 2000);


                    } else if (res.data.code == 404) {
                        this.overlay = false;
                        this.yuePayParam.payPass = "";
                        this.showToYuInvent = true;
                    } else {
                        this.overlay = false;
                        Dialog.alert({ title: "提示", message: res.data.message }).then((action) => {
                            this.yuePayParam.payPass = "";
                        }).catch(() => { });
                    }
                });
            }
        },
        sumbit() {
            var params = {
                iccid: this.$store.state.iccid,
                soldPackageId: this.dataForm.soldPackageId,
                isAdmin: this.dataForm.isAdmin,
                secondaryId: this.dataForm.secondaryId || '',
                primaryId: this.dataForm.primaryId || '',
                isNextMonth: this.dataForm.isNextMonth,
                payType: 20
            }
            var postUrl = "order/pkgOrder/add";
            var payType = "20";
            if (this.radio === 'aliCollectConfig') {   //支付宝支付
                postUrl = "order/ali/pkgOrder/add";
                payType = "80";
            } else if (this.radio === 'hfCollectConfig') {  //汇丰支付
                postUrl = "order/hfPkgOrder/add";
                payType = "60";
            } else if (this.radio === 'miCollectConfig') {  //米花支付
                postUrl = "order/ali/pkgOrder/add/mihua";
                payType = "90";
            } else if (this.radio === 'dhCollectConfig') {  //斗洪支付 
                postUrl = "order/ali/pkgOrder/add/dh";
                payType = "90";
            } else if (this.radio === 'yeCollectConfig') {  //余额支付
                postUrl = "order/user/uniorder";
                payType = "10";
            } else if (this.radio === 'hlCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/hl";
                payType = "90";
            } else if (this.radio === 'yyCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/yy";
                payType = "92";
            } else if (this.radio === 'longCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/long";
                payType = "93";
            } else if (this.radio === 'huoCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/huo";
                payType = "94";
            } else if (this.radio === 'wxCollectConfig') {  //斗洪支付
                postUrl = "order/pkgOrder/add";
                payType = "20";
            }else if (this.radio === 'bfCollectConfig') {  //斗洪支付
                postUrl = "order/ali/pkgOrder/add/bf";
                payType = "98";
            } else {
                Toast.success('请选择支付方式！');
                return;
            }

            if (payType == 10) {
                var paramsObj = {
                    newHome: localStorage.getItem("newHome"),
                    soldPackageId: null,
                    iccid: null,
                    isAdmin: 0,
                    isNextMonth: 0,
                    amount: 0,
                    giftBalance: 0,
                    payType: 40,
                    mobile: localStorage.getItem("mobile"),
                    source: localStorage.getItem("appid"),
                    payPass: null,
                    appid: localStorage.getItem("appid"),
                }
                for (let key in this.dataForm) {
                    paramsObj[key] = this.dataForm[key];
                }
                wxRequest("order/user/uniorder", paramsObj, "post").then((res) => {
                    if (res.data.code == 200) {
                        //已开户
                        this.yuePayParam.orderNo = res.data.data.id;
                        this.yuePayParam.iccid = localStorage.getItem("iccid");
                        this.yuePayParam.mobile = this.dataForm.mobile;

                        //唤起密码输入框
                        // this.showPasswordPanel = true;

                        this.onInput('000000');
                    } else if (res.data.data && res.data.data.accountInfo == "") {
                        this.showToYuInvent = true; //余额不足

                    } else {
                        this.$messagebox.alert(res.data.message);
                    }
                });
            } else {
                params.payType = payType;
                let formData = params;
                formData = new FormData();
                Object.keys(params).forEach((key) => {
                    formData.append(key, params[key]);
                });
                wxRequest(postUrl, formData, "post").then((res) => {
                    if (res.data.code == 200) {
                        if (params.payType == 92 || params.payType == 94|| params.payType == 98) {
                            //乐刷de
                            window.location.href = res.data.data;
                        } else if (params.payType == 20) {
                            //微信第三方
                            var param = res.data.data.param;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                    document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                        } else if (params.payType == 90 || params.payType == 93) {
                            //微信第三方
                            var param = res.data.data;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener("WeixinJSBridgeReady", this.onBridgeReady, false);
                                } else if (document.attachEvent) {
                                    document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                    document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                        } else if (params.payType == 60) {
                            //汇付天下
                            let datas = JSON.parse(res.data.data);
                            if (datas.status === "succeeded") {
                                let payment = datas;
                                AdaPay.doPay(payment, (res) => { Dialog.alert({ title: "提示", message: res.result_message }); });
                            }
                        } else if (params.payType == 80) {
                            // var ua = window.navigator.userAgent.toLowerCase();
                            // if (ua.match(/MicroMessenger/i) == "micromessenger") {
                            //     //进入引导页
                            //     this.is_WeChat = true;
                            //     var timer = setInterval(() => {
                            //         clearInterval(timer);
                            //         this.$router.push({
                            //             path: "/new/serviceCenter",
                            //             query: {
                            //                 row: encodeURIComponent(JSON.stringify(res.data.data)),
                            //             },
                            //         });
                            //     }, 1000);
                            // } else {
                            //     this.payUrl = res.data.data;
                            //     this.$nextTick(() => {
                            //         document.forms[0].submit();
                            //     });
                            // }
                            window.location.href = res.data.data;
                        }
                    } else {
                        Dialog.alert({ message: res.data.message });
                    }
                });
            }
            //支付成功之后页面跳转
            //  this.$router.push({path: '/new/equipmentCard'}); 
        },
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    Toast.success('订购成功');
                    setTimeout(function () {
                        _this.$router.push({
                            path: "/newUser/home",
                            query: {
                                iccid: _this.$store.state.iccid,
                            },
                        }).catch(() => { });
                    }, 1500);
                }
            });
        },
        aaaaa() {
            Dialog.confirm({
                title: '关于加油包自动续费须知',
                width: '90%',
                showCancelButton: false,
                messageAlign: 'left',
                confirmButtonColor: '#ee0a24',
                message: `当卡的套餐流量使用完毕时，系统会自动用余额来购买加油包 避免卡因套餐用完停机。点击勾选后 此业务生效。`,
            }).then(() => {
                // on confirm
            }).catch(() => {
                // on cancel
            });
        },

        async change(datas, index) {
            this.inx = index
            this.sObj = datas
            var data = {
                iccid: this.$store.state.iccid,
                soldPackageId: this.dataForm.soldPackageId,
                isAdmin: this.dataForm.isAdmin,
                secondaryId: this.dataForm.secondaryId || '',
                primaryId: this.dataForm.primaryId || '',
                isNextMonth: this.dataForm.isNextMonth,
                pkgId: this.dataForm.soldPackageId,
                amount: this.sObj.amount * 100,
                giftBalance: this.sObj.giftBalance,
                payType: 20,
                mobile: localStorage.getItem('userPhone')
            }

            wxRequest('sim/pay/type', { iccid: data.iccid }, 'post').then(res => {
                //查询是什么支付类型
                if (res.data.code == 406) {
                    data.payType = 60;
                } else if (res.data.code == 408) {
                    data.payType = 80;
                } else if (res.data.code == 409) {
                    data.payType = 90;
                } else if (res.data.code == 410) {
                    data.payType = 90;
                } else if (res.data.code == 491) {
                    data.payType = 90;
                } else if (res.data.code == 492) {
                    data.payType = 92;
                } else if (res.data.code == 493) {
                    data.payType = 90;
                } else if (res.data.code == 494) {
                    data.payType = 93;
                }else if (res.data.code == 498) {
                    data.payType = 98;
                }
                wxRequest('order/user/create/investOrder', data, 'post').then(res => {
                    if (res.data.code === "200") {
                        if (data.payType == 50) {
                            //乐刷de
                            window.location.href = res.data.data.jspay_url;
                        } else if (data.payType == 92 || data.payType == 93|| data.payType == 98) {
                            //云游
                            window.location.href = res.data.data;
                        } else if (data.payType == 20) {
                            //微信第三方
                            var param = res.data.data.param;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener(
                                        "WeixinJSBridgeReady",
                                        this.onBridgeReady,
                                        false
                                    );
                                } else if (document.attachEvent) {
                                    document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                    document.attachEvent(
                                        "onWeixinJSBridgeReady",
                                        this.onBridgeReady
                                    );
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                        } else if (data.payType == 90) {
                            //微信第三方
                            var param = res.data.data;
                            if (typeof WeixinJSBridge == "undefined") {
                                if (document.addEventListener) {
                                    document.addEventListener(
                                        "WeixinJSBridgeReady",
                                        this.onBridgeReady,
                                        false
                                    );
                                } else if (document.attachEvent) {
                                    document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                    document.attachEvent(
                                        "onWeixinJSBridgeReady",
                                        this.onBridgeReady
                                    );
                                }
                            } else {
                                this.onBridgeReady(param);
                            }
                        } else if (data.payType == 60) {
                            //汇付天下
                            let datas = JSON.parse(res.data.data);
                            if (datas.status === "succeeded") {
                                let payment = datas;
                                AdaPay.doPay(payment, (res) => {
                                    Dialog.alert({ title: "提示", message: res.result_message });
                                });
                            }
                        } else if (data.payType == 80) {
                            window.location.href = res.data.data;
                        }
                    } else {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    }
                });
            });

        },

    }
}
</script>
<style lang="less" scoped>
.page {
    // background: #F4F6FA;
    padding: 0 13px;
    background: linear-gradient(180deg, #3980F9 0%, rgba(244, 246, 250, 1) 240px);
    padding-bottom: 108px;
    height: calc(100% - 108px);
    position: relative;

    .top {
        // height: 180px;
        padding-top: 20px;

        .top-content {
            // height: 156px;
            width: calc(100% - 24px);
            background: #fff;
            border-radius: 10px;
            padding: 20px 12px;
            margin: 0 auto 10px;
        }

        .top-content-top {
            padding-bottom: 15px;
            display: flex;
            border-bottom: 1px solid #EDEDED;
            justify-content: space-between;
        }

        .top-content-top-items {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28292D;
            line-height: 22px;
        }

        .time {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #397EF5;
            line-height: 20px;
            // font-weight: bolder
        }

        .top-content-middle {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
        }
    }

    .section {
        width: 100%;
        margin: 30px auto 20px;

        .page-service {
            width: calc(100% - 22px);
            padding: 11px;
            border-radius: 10px;
            background: #E3EDFF;
        }

        .page-payment {
            border-radius: 10px;
            background: #fff;
            margin: auto;
            margin-top: 10px;
            width: calc(100% - 24px);
            padding: 11px;
            margin-bottom: 38px;

            .name {
                padding-bottom: 18px;
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #28292D;
                line-height: 25px;
            }

            .morePay {
                text-align: center;
                color: #4A75CD;
                //  color: #FAEBD7;
                margin-top: 10px;
            }
        }

        .wx-icon {
            // background: url('./../../assets/new/newCopy/icon03.png') left center no-repeat;
            background: url('./../../assets/new/newCopy/1.jpg') left center no-repeat;
            background-size: 26px 21px;
            padding: 30px 16px;
            padding-left: 35px;
        }

        .ali-icon {
            background: url('./../../assets/new/newCopy/icon02.png') left center no-repeat;
            background-size: 26px 26px;
            padding-left: 35px;
        }

        .yue-icon {
            background: url('./../../assets/new/newCopy/icon07.png') left center no-repeat;
            background-size: 26px 26px;
            padding-left: 35px;
        }

        .van-cell::after {
            border: none;
        }

        ::v-deep .van-cell-group::after {
            border: none;
        }

        .van-cell-group {
            background: none;
        }

        .v-checkbox {
            background: none;
            padding: 0;

            &:active {
                background: none;
            }

            .van-cell__title {
                span {
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #28292D;
                    line-height: 22px;
                }
            }
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        background: #fff;
        width: 100%;
        padding: 0;
        left: 0;

        .preferential {
            padding: 12px 35px 12px 11px;
            height: 22px;
            display: flex;
            width: 100%;
            align-items: center;
            background: #f7f8fa url('../../assets/new/newCopy/icon06.png') no-repeat 97% center;
            background-size: 9px 16px;
            border-bottom: 1px solid #ededed;
            box-sizing: border-box;

            .roll {
                width: 22px;
                height: 22px;
                flex-shrink: 0;
                border-radius: 4px;
                background: #FF894A;
                color: #fff;
                text-align: center;
                line-height: 22px;
            }

            .roll-up {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #28292D;
                padding-left: 8px;
            }

            .roll-proce {
                color: #397EF5;
                font-size: 14px;
                flex: 1;
                text-align: right;
                padding-right: 10px;
            }
        }

        .agreement {
            padding-left: 13px;
            color: #28292D;
            display: flex;
            align-items: center;

            span {
                color: #397EF5;
            }
        }

        .payment {
            display: flex;
            padding: 12px 0;
            align-items: center;
            justify-content: space-between;

            .payment-items {
                display: flex;
                padding-left: 13px;
                align-items: center;

                .price {
                    color: #397EF5;
                    font-size: 14px;
                    font-family: HarmonyOS_Sans_SC_Bold;

                    span {
                        font-size: 24px;
                    }
                }

                .price-small {
                    padding-left: 6px;
                    color: #63666D;
                    font-size: 14px;
                    text-decoration: line-through;
                    margin-top: 10px;
                }
            }

            .payment-btn {
                margin-right: 12px;

                .van-button {
                    width: 156px;
                }
            }
        }
    }
}

.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}

.shareit img {
    max-width: 100%;
}

.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}

.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    // height: 100rpx;
    line-height: 30px;
    // text-align: left;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}

.passwordPanel {
    p {
        text-align: center;
        color: "#323233";
        margin-bottom: 30px;
    }

    h1 {
        font-size: 28px;
        text-align: center;
        color: "#323233";
        margin: 30px 0;

        span {
            font-size: 20px;
        }
    }

    .van-cell-group {
        padding: 10px 5px;
    }
}

.dialog-text {
    font-size: 14px;
    color: #06121e;
    margin-top: 8px;
    line-height: 28px;
    padding: 0 10px;
}

.btn-vis {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10px;

    .dialog-btn2 {
        width: 120px;
        height: 47px;
        color: #3476fe;
        text-align: center;
        background: rgba(52, 118, 254, 0.1) !important;
        border: 0 !important;
        border-radius: 94px;
        font-size: 16px;
        line-height: 47px;
    }

    .dialog-btn3 {
        width: 130px;
        height: 47px;
        border-radius: 94px;
        font-size: 16px;
        line-height: 47px;
        border: 0;
        color: #fff;
        background: #3476fe;
        text-align: center;
    }
}

.c-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
}


.yue-swr {
    /* margin:14px; */
    background: #fff;
    /* padding:12px; */
    border-radius: 14px;
}

.b-z {
    font-size: 14px;
    color: #3476fe;
    line-height: 17px;
    font-family: PingFangSC, PingFang SC;
}

.c-z {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    margin-top: 15px;
    width: 30%;

    .c-z-item {
        width: 70%;
        position: relative;
        background: url('~@/assets/img/icon5.png') no-repeat center;
        background-size: 100% 100%;
        height: 76px;

        .items {
            width: 100%;
            font-weight: 600;
            font-size: 16px;
            justify-content: center;
            display: flex;
            align-items: center;
            color: #000000;
            padding-top: 25px;

            span {
                font-size: 12px;
            }
        }



        .item1 {
            font-size: 10px;
            color: #ccc;
            padding-top: 5px;
            text-align: center;
        }

        .f-d {
            font-weight: 600;
            color: #FFFFFF;
            font-size: 12px;
            width: 77%;
            height: 18px;
            line-height: 18px;
            position: absolute;
            left: 0;
            top: 0px;
            text-align: center;
            background: url('~@/assets/img/icon8.png') no-repeat center;
            background-size: 100% 100%;

        }
    }

    .c-z-active {
        background: url('~@/assets/img/icon7.png') no-repeat center;
        background-size: 100% 100%;

        .items {
            color: #fff;
        }

        .item1 {
            color: #fff;
        }

        .f-d {
            background: url('~@/assets/img/icon6.png') no-repeat center;
            background-size: 100% 100%;

        }
    }
}
</style>
<style>
.checkstand-page .cancelPay .van-button--round {
    float: right;
}

.checkstand-page .cancelInput .van-icon {
    margin: 10px 15px 10px 0;
    position: absolute;
    right: 0;
}

.checkstand-page .passwordPanel .van-field__label {
    width: 60px;
}

.checkstand-page .cancelInput .van-icon-close:before {
    font-size: 20px;
}

/* .checkstand-page .van-icon::before {
      line-height: 30px;
    } */

.checkstand-page .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.checkstand-page .block {
    width: 120px;
    height: 120px;
    background-color: #fff;
}

.checkstand-page .passwordPanel .van-field__control {
    line-height: 24px;
}

/* .checkstand-page .van-icon,
    .checkstand-page .van-icon::before {
      line-height: 62px;
    } */

.checkstand-page .van-divider {
    padding: 0;
    margin: 0;
}
</style>